<template>
<section class="pt-8 pt-md-5 pb-8 pb-md-14">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div v-if="$state.context.token">
                    <p>Please verify your Telegram account to:</p>
                    <ul>
                        <li>start a trial</li>
                        <li>access your balance details</li>
                        <li>receive notifications</li>
                    </ul>
                    <a
                        :href="`${$state.siteTgBase}/${$state.context.tg_bot}?start=${$state.context.token}`"
                        class="verify-link"
                        >
                        Verify on Telegram
                    </a>
                </div>
                <Spinner v-else />
            </div>
        </div>
    </div>
</section>
</template>

<script>
import Spinner from '../Spinner';

export default {
    components: { Spinner },
    data() {
        return {
        }
    },
}
</script>
